var Candidate = /** @class */ (function () {
    function Candidate() {
        this.id = null;
        this.name;
        this.firstName;
        this.lastName;
        this.workphone;
        this.mobilephone;
        this.email;
        this.im;
    }
    return Candidate;
}());
export { Candidate };
//# sourceMappingURL=candidate.js.map